import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateSkill } from "../../api/SkillApi";
import FormBase from "../../components/FormComponents/FormBase";
import GenericInput from "../../components/FormComponents/GenericInput";
import ModalForm from "../../components/FormComponents/ModalForm";
import { ISkill } from '../../core/interfaces/skill';


const EditSkillModal: React.FC<{
    show: boolean,
    hide: () => void,
    skill: ISkill
}> = ({
    show,
    hide,
    skill
}) => {
    const {t} = useTranslation();

    const [update, isUpdating] = useUpdateSkill(skill?.id);
    const [updatedObject, setUpdatedObject] = useState({ ...skill });

    const [errors, setErrors] = useState({
        name: true
    });

    const validate = (skill: ISkill, name: string) => {
        switch (name) {
            case 'name':
                errors.name = !skill.name.length;
                break;
        }

        setErrors(errors);
        return skill;
    }

    const commonProps = {
        isEditMode: true,
        object: updatedObject,
        errorObject: errors,
        setValue: setUpdatedObject,
        onChangeMiddleWare: validate,
    }

    useEffect(() => {
        setErrors({
            name: true
        });
        setUpdatedObject({
            ...skill
        });
    }, [skill])


    const handleSubmit = () => {
            const updated = _.cloneDeep(updatedObject) as ISkill;
            update(updated).then(_ => hide());
        }

        return (
            <ModalForm
                show={show}
                hide={hide}
                title={t('EditSkillModal.EDIT_SKILL_1')}
                isEdited={() => false}
                submit={handleSubmit}
                isLoading={isUpdating}
                disableSubmit={!!Object.values(errors).filter(s => s).length}>
                <FormBase row={false} controlId={'name'} title={t('EditSkillModal.SKILL_1')}
                    className={'pb-2'}>
                    <GenericInput name={'name'} {...commonProps} />
                </FormBase>
            </ModalForm>
        );
    };

export default EditSkillModal;